import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';

// pages
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const SetPassword = Loadable(lazy(() => import('pages/authentication/SetPassword')));
const ForgotPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const RegisterByInvite = Loadable(lazy(() => import('pages/authentication/RegisterByInvite')));

const LoginRoutes = {
  path: '/',
  children: [
    {
      index: true,
      element: <Navigate to="/login" replace />
    },
    {
      path: 'login',
      element: <LoginPage />
    },
    {
      path: 'password/set/:token',
      element: <SetPassword />
    },
    {
      path: 'forgot-password',
      element: <ForgotPassword />
    },
    {
      path: 'register/:token',
      element: <RegisterByInvite />
    }
  ]
};

export default LoginRoutes;
